import React from 'react'
import {Grid} from '@mui/material'
import {RequestDetailResponse} from '../../../types/requests'
import ReviewerComments from './ReviewerComments'
import AddComment from './AddComment'


export interface CommentSectionProps {
  requestDetail?: RequestDetailResponse | null
  showReviewerComments: boolean
  handleAddCommentClick: () => void
  setRequestDetail: React.Dispatch<React.SetStateAction<RequestDetailResponse | null>>
  setFieldsTouched: React.Dispatch<React.SetStateAction<{ reviewerComments: boolean; rows: boolean }>>
  hasChanged: boolean
  isDeclinedOrCancelled: boolean
  commentError?: boolean
  setCommentError?: React.Dispatch<React.SetStateAction<boolean>>
  showCommentsOnError?: boolean
}

const CommentSection: React.FC<CommentSectionProps> = function ({
                                                                  requestDetail,
                                                                  showReviewerComments,
                                                                  handleAddCommentClick,
                                                                  setRequestDetail,
                                                                  setFieldsTouched,
                                                                  hasChanged,
                                                                  isDeclinedOrCancelled,
                                                                  commentError,
                                                                  setCommentError
                                                                }) {
  return (
    <Grid item xs={12} style={{paddingTop: '0', marginTop: '0'}}>
      <AddComment onClick={handleAddCommentClick} />
      {showReviewerComments && requestDetail && (
        <ReviewerComments
          reviewerComments={requestDetail.reviewerComments || ''}
          onChange={e => {
            setRequestDetail(current => {
              const {reviewerComments, ...rest} = current as RequestDetailResponse
              return {reviewerComments: e.target.value, ...rest}
            })
            if (commentError && setCommentError) {
              setCommentError(true)
            }
          }}
          onBlur={() => {
            setFieldsTouched({reviewerComments: true, rows: false})
          }}
          error={!!((hasChanged || commentError) && requestDetail.reviewerComments === '')}
          disabled={isDeclinedOrCancelled}
        />
      )}
    </Grid>
  )
}

export default CommentSection